export enum ActionTypes {
    SET_DATE_RANGE = 'SET_DATE_RANGE',
    SET_OVERRIDE = 'SET_OVERRIDE'
}

export type ICalendarFilterActions = ISetDateRangeAction | ISetOverrideAction;

export interface ISetDateRangeAction {
    type: ActionTypes.SET_DATE_RANGE;
    data?: Date[];
    date?: Date;
    stateUpdateStatus?: boolean;
}

export interface ISetOverrideAction {
    type: ActionTypes.SET_OVERRIDE;
    data: boolean;
}
